<template>
	<div class="container">

		<div class="schoolBanner" v-if="college">
			<img :src="college.logo" />
			<span>{{college.name}}</span>
		</div>
		<div class="signtitle">
			在线签约系统
		</div>
		<div class="login-box">
			<img class="logo" src="../../assets/image/login-logo.png">
			<div class="title">手机号登录</div>
			<div class="content">
				<div class="item">
					<div></div>
					<input type="text" v-model="form.mobile" placeholder="请输入手机号码">
				</div>
				<div class="item">
					<div></div>
					<input type="text" v-model="form.vcode_verify.vcode_text" placeholder="请输入验证码">
					<img @click="getvCode" :src="imgCode" style="width: 120px;height: 30px;margin-left: 10px">
				</div>
				<div class="item">
					<div></div>
					<input type="text" v-model="vcodeText" placeholder="请输入手机验证码">
					<span v-if="!isSend" style="margin-left: 20px;font-size: 14px;color: #634AFF;cursor: pointer" @click="getSmsvCode">获取验证码</span>
					<span v-else style="margin-left: 20px;font-size: 14px;color: #634AFF">{{count}}s后获取</span>
				</div>
			</div>
			<div class="submit" @click="login">登录/注册</div>
		</div>
		<div class="footer">
			<img src="../../assets/image/logo_bottom.png">
		</div>


		<div v-show="alertChips" @click="closepopup">
			<!--这里是要展示的内容层-->
			<div class="alertBox">
				<img class="colseModel" src="../../assets/image/closeModel.png" />
				<div class="alertBox_title flex_c"><img src="../../assets/image/edit_yellow.png" /><span>签约须知</span></div>
				<div class="alertBox_content">{{alertText}}</div>
				<div class="alertBox_commit">确定</div>
			</div>
			<!--这里是半透明背景层-->
			<div class="over"></div>
		</div>
	</div>

</template>

<script>
	import {
		getvCode,
		getSmsvCode,
		login,
		getToken,
		getDepartment,
		getSignchip,
		getCollege,
		getCollegeSetting,
		isSign
	} from '@/api/login'

	export default {
		data() {
			return {
				form: {
					mobile: null,
					sms_type: 'login',
					vcode_verify: {
						vcodeid: '',
						vcode_text: ''
					}
				},
				isSend: false,
				count: 60,
				imgCode: '',
				vcodeText: '',
				college: null,
				alertChips: 0,
				alertText: '',
				su_number: null,
				loginFlag: true

			}
		},
		created() {
			console.log('params', this.$route.params);
			if (this.$route.params.id) {
				this.su_number = this.$route.params.id
			}
			this.getvCode()
		if (this.su_number) this.getSignDetail();
		},
		methods: {
			async getvCode() {
				const res = await getvCode()
				if (res) {
					this.imgCode = 'data:image/png;base64,' + res.vcode_image; //验证码图片base64
					this.form.vcode_verify.vcodeid = res.vcodeid;
				}
			},
			async getSmsvCode() {
				if (!this.form.mobile || !this.form.vcode_verify.vcode_text) {
					this.$message({
						message: '请填写手机号码和图片验证码'
					})
					return
				}
				const res = await getSmsvCode(this.form)
				if (res.code === 1) {
					this.$message({
						message: '发送成功',
						type: 'success'
					})
					console.log(res)
					this.isSend = true
					var timer = setInterval(() => {
						if (this.count > 1) {
							this.count--
						} else {
							this.count = 60
							this.isSend = false
							clearInterval(timer)
						}
					}, 1000);
				}
			},
			async login() {

				if (!this.vcodeText) {
					this.$message({
						message: '请填写手机验证码'
					})
					return
				}
				if (!this.loginFlag) {
					return
				}
				setTimeout(()=>{
					this.loginFlag = true
				}, 2000)
				this.loginFlag = false
				let model = {
					"mobile": this.form.mobile,
					"vcode": {
						"mobile": this.form.mobile,
						"vcode_text": this.vcodeText
					},
					"register_source": 'web', //注册来源
					"createip": "",
					"project_source": 'web', //项目来源
					"login_source": 'web' //登陆来源
				};
				const res = await login(model)
				if (res) {
					const _res = await getToken({
						"grant_type": "authorization_code",
						"code": res.value
					})
					if (_res) {
						localStorage.setItem("tokenInfo", JSON.stringify(_res))
						setTimeout(async () => {
							const __res = await getDepartment()
							if (__res) {
								if (__res.accountid) {
									localStorage.setItem("accountid", JSON.stringify(__res.accountid))
								}
								console.log(this.su_number)
							if (this.su_number) {
								this.$router.replace('/sign/' + this.su_number)
							} else {
								this.$router.replace('/signingList')
							}
								
								this.loginFlag = true
							}
						}, 100)
					}
				}
			},
			//获取签约信息
			async getSignDetail() {
				const res = await getSignchip(this.su_number)
				//department_sign_reminder
				if (res.department_sign_reminder) {
					this.alertText = res.department_sign_reminder;
					this.alertChips = 1;
				}
				this.getCollegeInfo(res.collegeid)
			},
			//获取高校信息
			async getCollegeInfo(id) {
				const res = await getCollege(id)
				this.college = res;
				this.signManager.college = res;
			},
			showpopup() {
				this.alertChips = 1;
			},
			closepopup() {
				this.alertChips = 0;
			},

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.login-box {
		position: relative;
		width: 564px;
		height: 506px;
		margin: 0 auto;
		transform: translateY(40px);
		padding: 30px 20px;
		border-radius: 5px;
		border: 1px solid #EEEEEE;

		.logo {
			width: 124px;
			height: 40px;
			position: absolute;
			right: 0;
			top: 0;
		}

		.title {
			font-weight: 600;
			font-size: 18px;
			margin: 30px 0;
		}

		.content {
			margin-top: 50px;

			.item {
				margin-top: 30px;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #EEEEEE;

				input {
					padding-left: 40px;
					width: 360px;
					height: 44px;
					border: none;
				}
			}
		}

		.submit {
			width: 380px;
			height: 44px;
			text-align: center;
			font-size: 18px;
			line-height: 44px;
			margin: 120px auto 0;
			color: #ffffff;
			background: #5E4FFF;
			border-radius: 5px;
			cursor: pointer;
		}

		input:focus {
			border: none;
			background: #fff;
			outline: none;
		}
	}

	.footer {
		width: 100%;
		height: 200px;

		img {
			width: 100%;
			height: 200px;
		}
	}

	.schoolBanner {
		width: 606px;
		height: 70px;
		margin: 40px auto 0 auto;
	}

	.schoolBanner img {
		width: 70px;
		height: 70px;
		float: left;
		border-radius: 35px;
		color: #333333;
	}

	.schoolBanner span {
		font-size: 30px;
		margin-left: 10px;
		font-weight: bold;
		line-height: 70px;
	}

	.signtitle {
		width: 606px;
		height: 51px;
		margin: 7.8125rem auto 0 auto;
		text-align: center;
		font-family: 'zhenyan';
		font-size: 50px;
		line-height: 51px;
		color: #5e4fff;
	}

	@media (max-width:46.875rem) {
		.signtitle{
			margin: 2.8125rem auto 0 auto;
		}
	}

	//这里面可以自定义字体样式等，都是CSS基础
	.rule {
		position: absolute;
		width: 0.82rem;
		height: 0.36rem;
		top: 0.08rem;
		right: 0rem;
		background: #111111;
	}

	.alertBox {
		position: fixed;
		font-size: 24px;
		height: 212px;
		width: 385px;
		border-radius: 0.25rem;
		background-color: white;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 1000;
		background: url("../../assets/image/downLineBg.png") no-repeat;
		background-size: 385px 212px;

	}

	.over {
		position: fixed;
		width: 100%;
		height: 100%;
		opacity: 0.4; //透明度为70%
		filter: alpha(opacity=70);
		top: 0;
		left: 0;
		z-index: 999;
		background-color: #111111;
	}

	.alertBox_title {
		width: 100%;
		height: 25px;
		line-height: 25px;
		color: #333333;
		font-size: 18px;
		text-align: center;
		margin-top: 40px;
	}

	.alertBox_content {
		width: 300px;
		height: 60px;
		line-height: 20px;
		font-size: 16px;
		color: #333333;
		margin: 10px auto 22px auto;
		overflow-y: auto
	}

	.alertBox_commit {
		width: 160px;
		height: 36px;
		background-color: #5e4fff;
		color: white;
		text-align: center;
		line-height: 36px;
		margin: 0 auto;
		font-size: 16px;
		border-radius: 4px;
		cursor: pointer;
	}

	.alertBox_title img {
		width: 20px;
		height: 20px;
		margin-right: 4px;
	}

	.colseModel {
		width: 15px;
		height: 14px;
		position: absolute;
		right: 12px;
		top: 12px;
		cursor: pointer;
	}

	@media (max-width:46.875rem) {
		.schoolBanner {
			width: 20rem !important;
			;
		}

		.signtitle {
			width: 20rem !important;
		}

		.login-box {
			width: 20rem;
			height: 25rem;

			.content {
				width: 20rem !important;
				margin-top: 1.875rem;
			}

			.item {
				margin-top: 30px;
				display: flex;
				align-items: center;
				border-bottom: 1px solid #EEEEEE;

				input {
					padding-left: 1rem;
					width: 9rem !important;
					height: 44px;
				}
			}

			.submit {
				width: 20rem !important;
				margin: 50px auto 0;
			}
		}

	}
</style>
